import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CounterpartyBankAccountRequest {
  /**
   * Account number.
   */
  @observable
  accountNumber?: string;

  /**
   * Bank.
   */
  @observable
  bank?: string;
}

export const CounterpartyBankAccountRequestValidationRules: EntityValidationRules<CounterpartyBankAccountRequest> = {
  accountNumber: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
};
